import { IIconProps } from './Types';

export const SortingArrowUpIcon = ({ color = '#576264', size = 16 }: IIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height="8" viewBox="0 0 16 8" fill="none">
      <path d="M16 8L8 -8.18592e-07L-2.38419e-07 8L16 8Z" fill={color} />
    </svg>
  );
};
